export default "__VITE_ASSET__DZdMZxK7__"